
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21zm-19.468.822h3.747l.496-4.82h-4.242v-2.84c0-1.064.703-1.314 1.204-1.314h3.051V8.165l-4.205-.018c-4.667 0-5.728 3.496-5.728 5.729v3.122h-2.7v4.824h2.7V35.55h5.677V21.822z","fill":"#fff"}})])
          )
        }
      }
    